import request from '@/utils/request'


// 查询对公账户列表
export function listBusinessAccount(query) {
  return request({
    url: '/biz/admin/platform/business/account/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询对公账户分页
export function pageBusinessAccount(query) {
  return request({
    url: '/biz/admin/platform/business/account/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询对公账户详细
export function getBusinessAccount(data) {
  return request({
    url: '/biz/admin/platform/business/account/detail',
    method: 'get',
    params: data
  })
}

// 新增对公账户
export function addBusinessAccount(data) {
  return request({
    url: '/biz/admin/platform/business/account/add',
    method: 'post',
    data: data
  })
}

// 修改对公账户
export function updateBusinessAccount(data) {
  return request({
    url: '/biz/admin/platform/business/account/edit',
    method: 'post',
    data: data
  })
}

// 删除对公账户
export function delBusinessAccount(data) {
  return request({
    url: '/biz/admin/platform/business/account/delete',
    method: 'post',
    data: data
  })
}
